import React, { useEffect, useState } from "react";
import axios from "axios";
import "./RoleManagement.css";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.quote.softvolute.in";

const MODULES = [
  { key: "quote", label: "Quote" },
  { key: "clientDetail", label: "Client Detail" },
  { key: "paymentDetail", label: "Income / Expense Detail" },
  { key: "vendorQuote", label: "Vendor Quote" },
  { key: "vendorPO", label: "Vendor PO" },
  { key: "paymentReport", label: "Payment Report" },
  { key: "salesDashboard", label: "Sales Dashboard" },
  { key: "project", label: "Project" },
  { key: "home", label: "Home Page" },
  { key: "afterBooking", label: "Active Projects by Milestone" },
];

const MODULE_ACTIONS = {
  quote: [
    { key: "view", label: "View" },
    { key: "create", label: "Create" },
    { key: "edit", label: "Edit" },
    { key: "delete", label: "Delete" },
    { key: "approve", label: "Approve" },
    { key: "viewAll", label: "View All" },
    { key: "quoteAddItem", label: "Add Item" },
    { key: "quoteCreateCustomer", label: "Create Customer Quote" },
    { key: "quoteAddCustomItem", label: "Add Custom Item" },
    { key: "quoteEditSaved", label: "Edit Saved Quote" },
    { key: "quoteApproveReject", label: "Approve / Reject" },
    { key: "quoteExportPdf", label: "Export PDF" },
    { key: "quoteExportExcel", label: "Export Excel" },
    { key: "quoteSendMail", label: "Send Mail" },
    { key: "quoteShowPrice", label: "Show Price" },
    { key: "quoteShowFinalAmount", label: "Show Final Amount" },
    // ✅ CATEGORY ACCESS
    { key: "kitchen", label: "Kitchen Category" },
    { key: "looseFurniture", label: "Loose Furniture Category" },
    { key: "siteService", label: "Site Service Category" },
    { key: "godrejInterio", label: "Godrej Interio Category" },
    { key: "modularFurniture", label: "Modular Furniture Category" },
  ],
  home: [
    { key: "view", label: "View Home Page" },
    { key: "clientDetail", label: "Client Detail Card" },
    { key: "quote", label: "Quote Card" },
    { key: "paymentDetail", label: "Payment Detail Card" },
    { key: "drawings3D", label: "Drawings & 3D Card" },
    { key: "vendorQuote", label: "Vendor Cost & Payments Card" },
    { key: "recce", label: "Recce Card" },
    { key: "siteProgress", label: "Site Progress Card" },
    { key: "vendorEstimate", label: "Vendor Estimate Card" },
  ],
  clientDetail: [
    { key: "view", label: "View" },
    { key: "create", label: "Create / Save" },
    { key: "edit", label: "Edit" },
    { key: "delete", label: "Delete" },
    { key: "viewAll", label: "View All" },
    { key: "clientName", label: "Client Name" },
    { key: "clientAddress", label: "Client Address" },
    { key: "phoneNumber", label: "Phone Number" },
    { key: "email", label: "Email" },
    { key: "possessionDate", label: "Possession Date" },
    { key: "siteAddress", label: "Site Address" },
    { key: "clientDetailAssignSalesManager", label: "Assign Sales Manager" },
    { key: "clientDetailShowBudget", label: "Show Budget" },
    { key: "homeType", label: "Home Type" },
    { key: "clientDetailShowPAN", label: "Show PAN" },
    { key: "clientDetailShowGST", label: "Show GST" },
  ],
  paymentDetail: [
    { key: "view", label: "View Full Page" },
    { key: "paymentShowProjectService", label: "Project / Service Details" },
    {
      key: "paymentEditProjectService",
      label: "Edit Project / Service Details",
    },
    { key: "paymentShowIncomeStatus", label: "Income Status" },
    { key: "paymentShowExpenseStatus", label: "Expense Status" },
    { key: "paymentShowActualBalance", label: "Actual Balance on Hand" },
    { key: "paymentShowCustomerSO", label: "Customer Estimate / Sales Order" },
    { key: "paymentShowIncomeTable", label: "Income Table" },
    { key: "create", label: "Income - Add" },
    { key: "edit", label: "Income - Edit" },
    { key: "delete", label: "Income - Delete" },
    { key: "paymentShowTaxableValue", label: "Income - Taxable Value" },
    { key: "paymentShowGST", label: "Income - GST" },
    { key: "paymentShowInvoiceAmount", label: "Income - Invoice Amount" },
    { key: "paymentShowPendingClient", label: "Income - Pending From Client" },
    { key: "paymentShowExpenseTable", label: "Final Paid Expenses Table" },
    { key: "paymentShowVendorPayment", label: "Expense - Payment Amount" },
  ],
  vendorQuote: [
    { key: "view", label: "View Vendor Summary Page" },
    { key: "vendorQuoteShowPOSummary", label: "Vendor PO Summary Table" },
    { key: "vendorQuoteShowDuplicateAlert", label: "Duplicate Item Alert" },
    { key: "vendorQuoteExportExcel", label: "Export Excel" },
    { key: "vendorQuoteCreatePayment", label: "Create Payment Intimation" },
    { key: "vendorQuoteShowPaymentInfo", label: "Show Payment Balance Info" },
    {
      key: "vendorQuoteShowPendingApproval",
      label: "Pending Approval Requests",
    },
    { key: "vendorQuoteApproveReject", label: "Approve / Reject Payment" },
    { key: "vendorQuoteShowApprovedRequests", label: "Approved Requests" },
    { key: "vendorQuoteMarkPaid", label: "Mark Paid" },
    { key: "vendorQuoteShowVendorMaster", label: "Vendor Master Button" },
  ],
  vendorPO: [
    { key: "view", label: "View Vendor PO Button" },
    { key: "create", label: "Create Vendor PO" },
    { key: "edit", label: "Edit Vendor PO" },
    { key: "delete", label: "Delete Vendor PO" },
  ],
  paymentReport: [
    { key: "view", label: "View Payment Report Page" },
    { key: "reportShowBreakdown", label: "Day / Month-wise Breakdown" },
    { key: "reportShowEntries", label: "Entries Table" },
    { key: "reportExportExcel", label: "Export Excel" },
  ],
  afterBooking: [
    { key: "afterBookingShowRevenue", label: "Revenue Achieved" },
    { key: "afterBookingShowMilestones", label: "Project Milestones" },
  ],
  salesDashboard: [
    { key: "view", label: "View" },
    { key: "create", label: "Create Lead" },
    { key: "edit", label: "Edit Lead" },
    { key: "delete", label: "Delete Lead" },
    { key: "viewAll", label: "View All Leads" },
  ],
  project: [
    { key: "view", label: "View" },
    { key: "create", label: "Create" },
    { key: "edit", label: "Edit" },
    { key: "delete", label: "Delete" },
    { key: "viewAll", label: "View All Projects" },
  ],
};

const emptyPermissions = () => {
  const obj = {};
  MODULES.forEach((m) => {
    obj[m.key] = {};
    (MODULE_ACTIONS[m.key] || []).forEach((a) => {
      obj[m.key][a.key] = false;
    });
  });
  return obj;
};

const makeAdminPermissions = () => {
  const obj = {};
  MODULES.forEach((m) => {
    obj[m.key] = {};
    (MODULE_ACTIONS[m.key] || []).forEach((a) => {
      obj[m.key][a.key] = true;
    });
  });
  return obj;
};

const normalizeRole = (role = {}) => {
  const roleKey = String(role.roleKey || "")
    .toLowerCase()
    .trim();
  const base =
    roleKey === "admin" ? makeAdminPermissions() : emptyPermissions();

  MODULES.forEach((m) => {
    (MODULE_ACTIONS[m.key] || []).forEach((a) => {
      if (role.permissions?.[m.key]?.[a.key] !== undefined) {
        base[m.key][a.key] = Boolean(role.permissions[m.key][a.key]);
      }
    });
  });

  return {
    _id: role._id || null,
    roleName: role.roleName || "",
    roleKey,
    permissions: base,
  };
};

export default function RoleManagement() {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  const getToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("userToken") ||
      ""
    );
  };

  const getAuthHeaders = () => {
    const token = getToken();

    if (!token) {
      throw new Error("LOGIN_REQUIRED");
    }

    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const handleAuthError = (err) => {
    if (
      err.message === "LOGIN_REQUIRED" ||
      err.response?.status === 401 ||
      err.response?.data?.message === "Invalid token"
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("authToken");
      localStorage.removeItem("userToken");
      localStorage.removeItem("user");
      alert("Session expired. Please login again.");
      window.location.href = "/login";
      return true;
    }

    return false;
  };

  const fetchRoles = async (keepRoleKey = null) => {
    try {
      setLoading(true);

      const roleRes = await axios.get(`${BASE_URL}/api/users/roles`, {
        headers: getAuthHeaders(),
      });

      const backendRoles = Array.isArray(roleRes.data) ? roleRes.data : [];

      const permissionRes = await axios.get(`${BASE_URL}/api/roles`, {
        headers: getAuthHeaders(),
      });

      const savedPermissions = Array.isArray(permissionRes.data)
        ? permissionRes.data
        : [];

      const finalRoles = backendRoles.map((r) => {
        const cleanKey = String(
          r.roleKey || r.role || r.roleName || r.name || "",
        )
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "_");

        const saved = savedPermissions.find(
          (p) =>
            String(p.roleKey || "")
              .toLowerCase()
              .trim()
              .replace(/\s+/g, "_") === cleanKey,
        );

        return normalizeRole({
          _id: saved?._id || null,
          roleName: saved?.roleName || r.roleName || r.name || cleanKey,
          roleKey: cleanKey,
          permissions: saved?.permissions || {},
        });
      });

      setRoles(finalRoles);

      const selectedKey =
        keepRoleKey ||
        String(selectedRole?.roleKey || "")
          .toLowerCase()
          .trim();

      const nextSelected =
        finalRoles.find((r) => r.roleKey === selectedKey) ||
        finalRoles[0] ||
        null;

      setSelectedRole(nextSelected);
    } catch (err) {
      console.error("Role fetch error:", err);

      if (!handleAuthError(err)) {
        alert(
          err.response?.data?.message || err.message || "Roles load failed",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectRole = (role) => {
    setSelectedRole(normalizeRole(role));

    // On a phone the details are below the roles list: scroll down to them.
    if (window.innerWidth <= 900) {
      setTimeout(() => {
        document
          .getElementById("role-details")
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
  };

  const togglePermission = (moduleKey, actionKey) => {
    if (!selectedRole || selectedRole.roleKey === "admin") return;

    setSelectedRole((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [moduleKey]: {
          ...prev.permissions[moduleKey],
          [actionKey]: !prev.permissions[moduleKey]?.[actionKey],
        },
      },
    }));
  };

  const toggleModuleAll = (moduleKey, checked) => {
    if (!selectedRole || selectedRole.roleKey === "admin") return;

    const updated = {};
    (MODULE_ACTIONS[moduleKey] || []).forEach((a) => {
      updated[a.key] = checked;
    });

    setSelectedRole((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [moduleKey]: updated,
      },
    }));
  };

  const saveRole = async () => {
    if (!selectedRole) return;

    try {
      setSaving(true);

      const payload = {
        roleName: selectedRole.roleName,
        roleKey: selectedRole.roleKey,
        permissions:
          selectedRole.roleKey === "admin"
            ? makeAdminPermissions()
            : selectedRole.permissions,
      };

      let savedRole = null;

      if (selectedRole._id) {
        const res = await axios.put(
          `${BASE_URL}/api/roles/${selectedRole._id}`,
          payload,
          { headers: getAuthHeaders() },
        );
        savedRole = res.data?.role || res.data;
      } else {
        const res = await axios.post(`${BASE_URL}/api/roles`, payload, {
          headers: getAuthHeaders(),
        });
        savedRole = res.data?.role || res.data;
      }

      const updatedSelected = normalizeRole({
        _id: savedRole?._id || selectedRole._id,
        roleName: savedRole?.roleName || selectedRole.roleName,
        roleKey: savedRole?.roleKey || selectedRole.roleKey,
        permissions: savedRole?.permissions || selectedRole.permissions,
      });

      setSelectedRole(updatedSelected);

      setRoles((prev) =>
        prev.map((r) =>
          r.roleKey === updatedSelected.roleKey ? updatedSelected : r,
        ),
      );

      alert("Role permission saved");
      await fetchRoles(updatedSelected.roleKey);
    } catch (err) {
      console.error("Save role error:", err);
      console.log("SAVE STATUS =", err?.response?.status);
      console.log("SAVE DATA =", err?.response?.data);

      if (!handleAuthError(err)) {
        alert(err.response?.data?.message || err.message || "Save failed");
      }
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="rm-state">Loading roles...</div>;
  }

  if (!selectedRole) {
    return (
      <div className="rm-state">
        No roles found. Please check backend route: <b>/api/users/roles</b>
      </div>
    );
  }

  return (
    <div className="rm-page">
      <div className="rm-left">
        <div className="rm-left-title">Roles</div>

        <div className="rm-table-head">
          <span>S.No</span>
          <span>Role Name</span>
          <span>Type</span>
        </div>

        {roles.map((role, index) => {
          const active = selectedRole.roleKey === role.roleKey;

          return (
            <div
              key={role.roleKey}
              className={`rm-role-row${active ? " active" : ""}`}
              onClick={() => selectRole(role)}
            >
              <span>{index + 1}</span>
              <span className="rm-role-name">{role.roleName}</span>
              <span>{role._id ? "Saved" : "Default"}</span>
            </div>
          );
        })}
      </div>

      <div id="role-details" className="rm-right">
        <div className="rm-header">
          <h2>Role Details</h2>

          <button className="rm-save-btn" onClick={saveRole} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        </div>

        <div className="rm-form-grid">
          <div>
            <label className="rm-label">Role Name</label>
            <input
              className="rm-input"
              value={selectedRole.roleName}
              disabled
            />
          </div>

          <div>
            <label className="rm-label">Role Key</label>
            <input className="rm-input" value={selectedRole.roleKey} disabled />
          </div>
        </div>

        {selectedRole.roleKey === "admin" && (
          <div className="rm-admin-note">
            Admin role has full access. Permissions are always enabled.
          </div>
        )}

        <div className="rm-permission-box">
          <div className="rm-permission-title">Module Level Permissions</div>

          {MODULES.map((module) => {
            const moduleActions = MODULE_ACTIONS[module.key] || [];
            const modulePerms = selectedRole.permissions?.[module.key] || {};
            const allChecked = moduleActions.every((a) =>
              Boolean(modulePerms[a.key]),
            );

            return (
              <div key={module.key} className="rm-module-block">
                <div className="rm-module-header">
                  <label className="rm-module-title">
                    <input
                      type="checkbox"
                      checked={allChecked}
                      disabled={selectedRole.roleKey === "admin"}
                      onChange={(e) =>
                        toggleModuleAll(module.key, e.target.checked)
                      }
                    />
                    {module.label}
                  </label>
                </div>

                <div className="rm-action-grid">
                  {moduleActions.map((action) => (
                    <label key={action.key} className="rm-check-label">
                      <input
                        type="checkbox"
                        checked={Boolean(modulePerms[action.key])}
                        disabled={selectedRole.roleKey === "admin"}
                        onChange={() =>
                          togglePermission(module.key, action.key)
                        }
                      />
                      {action.label}
                    </label>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Shown on phones only (hidden by CSS on laptop) */}
        <div className="rm-bottom-save">
          <button className="rm-save-btn" onClick={saveRole} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
